import * as React from "react";
import { cn } from "@/lib/utils";

interface GradientTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  /** Kept for backward compatibility; no longer has any visual effect */
  accent?: boolean;
  /** Kept for backward compatibility; no longer has any visual effect */
  gradient?: string;
  /** HTML element to render */
  as?: "span" | "h1" | "h2" | "h3" | "h4" | "p";
}

/**
 * GradientText
 *
 * Renders text with standard foreground color.
 * Previously applied gradient fills; now renders plain text for a neutral theme.
 */
export function GradientText({
  children,
  accent: _accent,
  gradient: _gradient,
  as: Component = "span",
  className,
  ...props
}: GradientTextProps) {
  return (
    <Component className={cn("text-foreground", className)} {...props}>
      {children}
    </Component>
  );
}

/**
 * SectionLabel
 *
 * Small uppercase label for section headers.
 */
export function SectionLabel({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border border-border bg-muted px-3 py-1 text-xs font-medium tracking-wider text-muted-foreground uppercase",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
